import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

export const InformationTitle = styled.h2`
  margin-left: 1rem;
  font: ${brandFont.headerThree};
  color: ${({ theme }) => theme.token('text-default')};

  ${Styles.desktop`
    margin-top: 1rem;
    margin-bottom: 1.125rem;
  `}
`;

export const NutritionInformationWrapper = styled.div`
  ${Styles.desktop`
    margin: 0 -1rem;
  `}
`;
